import styled from 'styled-components';
import { DivWithShadowAlternate } from '@styled';
import { mediaQueries } from '@general/breakpoints';
import colors from '@general/colors';
import fonts from '@general/fonts';

const breakpoint = mediaQueries.md;

export const ContainerStyled = styled(DivWithShadowAlternate)`
    margin-bottom: 16px;
    position: relative;

    .tooltip {
        filter: drop-shadow(0px 0px 12px rgba(87, 87, 87, 0.3));
        background-color: #fff;
        opacity: 1;
        padding: 8px 16px;
        white-space: nowrap;
        z-index: 999999;
    }
`;

export const ContainerClickableStyled = styled.div`
    border-left: 8px solid ${props => (props.isActive ? colors.azure : colors.white)};
    cursor: pointer;
    padding: 9px;
    :hover {
        border-color: ${colors.azure};
    }
`;

export const ContainerInnerStyled = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
`;

export const SettingsButtonStyled = styled.button`
    border: none;
    background-color: transparent;
    cursor: pointer;
    position: absolute;
    right: 8px;
    top: 8px;
`;

export const LastMessageTimeStyled = styled.p`
    font-size: 0.8rem;
    color: #333333;
    margin-bottom: 0;
    text-align: right;
    margin-right: 15px;
    margin-left: 30px;
    line-height: 1.2rem;
    @media ${breakpoint} {
        display: block;
    }
`;

export const LastMessageTextStyled = styled.p`
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: calc(90%);
    flex: 1;
    margin-top: 5px;
    line-height: 1.2rem;
    font-size: 0.9rem;
    margin-bottom: 0;
    color: ${props => (props.hasNew ? '#000' : '#5F5F5F')};
    @media ${breakpoint} {
        display: block;
    }
`;

export const NameStyled = styled.p`
    font-size: 0.9rem;
    line-height: 1.2rem;
    margin-bottom: 0;
    font-weight: ${props => (props.hasNew ? 700 : 300)};
    @media ${breakpoint} {
        display: block;
    }
`;

export const NewMessagesBadgeStyled = styled.span`
    text-align: center;
    background-color: ${colors.azure};
    border-radius: 100%;
    font-family: ${fonts.sans};
    color: ${colors.white};
    padding: 3px 0 0;
    font-size: 0.8rem;
    font-weight: 700;
    position: absolute;
    right: -30px;
    top: -2px;
    height: 26px;
    width: 26px;
    @media ${breakpoint} {
        display: block;
    }
`;
